import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import Select from 'react-select';

import { crearUsuario } from '../../actions/usuarios';
import { CustomValueContainer } from '../../components/react_select/ReactSelect';

const styles_select = {
    menuPortal: base => ({ ...base, zIndex: 9999 }),
    container: (provided, state) => ({
        ...provided,
    }),
    control: (provided, state) => ({
        ...provided,
        paddingTop: '5px',
        paddingBottom: '5px',
    }),
    valueContainer: (provided, state) => ({
        ...provided,
        overflow: "visible",
        marginTop: "10px"
    }),
    placeholder: (provided, state) => ({
        ...provided,
        position: "absolute",
        top: state.hasValue || state.selectProps.inputValue ? -15 : "0%",
        transition: "top 0.1s, font-size 0.1s",
        fontSize: (state.hasValue || state.selectProps.inputValue) && 13
    })
};

const tiposUsuario = [
    { value: 0, label: 'Administrador' },
    { value: 1, label: 'Asistente' }
];

const NuevoUsuario = ({ show, handleCerrar }) => {

    const dispatch = useDispatch();

    const [usuarioData, setUsuarioData] = useState({
        tipo: null,
        nombre: null,
        apellido_paterno: null,
        apellido_materno: null,
        email: null,
        password: null
    });

    const [tipoData, setTipoData] = useState(null);
    const [statusProcesar, setStatusProcesar] = useState(false);

    const handleInputChange = ({ target }) => {
        setUsuarioData({ ...usuarioData, [target.name]: target.value });
    };

    const handleSelectTipo = (option) => {
        setTipoData(option);
        setUsuarioData({ ...usuarioData, tipo: option?.value ?? null });
    };

    const handleClose = () => {
        setUsuarioData({
            tipo: null,
            nombre: null,
            apellido_paterno: null,
            apellido_materno: null,
            email: null,
            password: null
        });
        setTipoData(null);
        handleCerrar();
    };

    const handleSubmit = async () => {
        setStatusProcesar(true);
        await dispatch(crearUsuario(usuarioData));
        setStatusProcesar(false);
        handleClose();
    };

    return (
        <Modal show={show} backdrop="static" centered onHide={handleClose}>
            <Modal.Header closeButton>
                <Modal.Title>Nuevo usuario</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="row">
                    <div className="col-md-6 form-group mb-3">
                        <div className="input-group h-100">
                            <Select
                                name="tipo"
                                className="select-group"
                                classNamePrefix="react-select"
                                placeholder="Tipo de usuario"
                                options={tiposUsuario}
                                value={tipoData}
                                onChange={handleSelectTipo}
                                menuPortalTarget={document.body}
                                components={{ ValueContainer: CustomValueContainer }}
                                styles={{ ...styles_select }}
                                isClearable
                            />
                        </div>
                    </div>
                    <div className="col-md-6 mb-3">
                        <div className="form-floating">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Nombre"
                                id="nombre"
                                name="nombre"
                                value={usuarioData.nombre || ''}
                                onChange={handleInputChange}
                            />
                            <label htmlFor="nombre">Nombre</label>
                        </div>
                    </div>
                    <div className="col-md-6 mb-3">
                        <div className="form-floating">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Apellido paterno"
                                id="apellido_paterno"
                                name="apellido_paterno"
                                value={usuarioData.apellido_paterno || ''}
                                onChange={handleInputChange}
                            />
                            <label htmlFor="apellido_paterno">Apellido paterno</label>
                        </div>
                    </div>
                    <div className="col-md-6 mb-3">
                        <div className="form-floating">
                            <input
                                type="text"
                                className="form-control"
                                placeholder="Apellido materno"
                                id="apellido_materno"
                                name="apellido_materno"
                                value={usuarioData.apellido_materno || ''}
                                onChange={handleInputChange}
                            />
                            <label htmlFor="apellido_materno">Apellido materno</label>
                        </div>
                    </div>
                    <div className="col-md-6 mb-3">
                        <div className="form-floating">
                            <input
                                type="email"
                                className="form-control"
                                placeholder="Correo electrónico"
                                id="email"
                                name="email"
                                value={usuarioData.email || ''}
                                onChange={handleInputChange}
                            />
                            <label htmlFor="email">Correo electrónico</label>
                        </div>
                    </div>
                    <div className="col-md-6 mb-3">
                        <div className="form-floating">
                            <input
                                type="password"
                                className="form-control"
                                placeholder="Contraseña"
                                id="password"
                                name="password"
                                value={usuarioData.password || ''}
                                onChange={handleInputChange}
                            />
                            <label htmlFor="password">Contraseña</label>
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" onClick={handleClose} disabled={statusProcesar}>
                    Cancelar
                </button>
                {
                    statusProcesar
                        ? <button className="btn btn-success" disabled><span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span> Guardando</button>
                        : <button className="btn btn-success" onClick={handleSubmit}><i className="fas fa-check me-1"></i> Guardar</button>
                }
            </Modal.Footer>
        </Modal>
    );
};

export default NuevoUsuario;
